module.exports = __webpack_public_path__ + "img/image20.cfb32071.svg";